import React from 'react';
import withStore from "@/hocs/withStore";
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import LinkLoad from "@/Layouts/LinkLoad";

const BreadcrumbsCatalog = ({...props}) => {
    const {stores = {}} = props;
    const {filterStore = {}} = stores

    let url = '';

    let bread = filterStore.allChips.filter((el) => {
        if (
            el.nameAlias !== 'sale' &&
            el.nameAlias !== 'insertsColor' &&
            el.nameAlias !== 'weaving' &&
            el.nameAlias !== 'viewDesign' &&
            el.nameAlias !== 'thematics' &&
            el.nameAlias !== 'collection' &&
            el.nameAlias !== 'size' &&
            el.nameAlias !== 'stock' &&
            el.nameAlias !== 'price'
        ) {
            return el;
        }
    });

    let urlControl = [];

    bread.forEach((el, i) => {
        if (bread.length !== i + 1) {
            url += `/${el.valueAlias}`;
            urlControl.push(url);
        }
    });

    let breadRes = bread.map((el, i, arr) => {
        if (i + 1 !== bread.length) {
            url += `/${el.valueAlias}`;

            return <LinkLoad className="breadcrumbs__link"
                         key={el.id}
                         href={`/catalog${urlControl[i]}`}
            >
                {el.value}
            </LinkLoad>
        } else {
            return <div className={`breadcrumbs__text`}
                        key={el.id}>
                {el.value}
            </div>
        }
    });

    return (
        <div className={`breadcrumbs`}>
            <div className="container">
                <Breadcrumbs
                    maxItems={4}
                    itemsAfterCollapse={3}
                >
                    <LinkLoad className="breadcrumbs__link"
                          href={`/catalog`}
                    >
                        Каталог
                    </LinkLoad>
                    {breadRes}
                </Breadcrumbs>
            </div>
        </div>
    )
}

export default withStore(BreadcrumbsCatalog)
